export enum GroupId {
    Actions = 'actions',
    Ads = 'ads',
    Analytics = 'analytics',
    BrandSocial = 'brand-social',
    CompetitiveInsights = 'competitive-insights',
    Customer = 'customer',
    Datastore = 'datastore',
    Directory = 'directory',
    Location = 'location',
    GoogleSellerRatings = 'google-seller-ratings',
    Inbox = 'inbox',
    Kiosk = 'kiosk',
    Navads = 'navads',
    Platform = 'platform',
    QA = 'qa',
    Reviews = 'reviews',
    Reports = 'reports',
    Requests = 'requests',
    Score = 'score',
    SearchInsights = 'search-insights',
    Social = 'social',
    SocialListening = 'social-listening',
    Surveys = 'surveys',
    Tasks = 'tasks',
    Yelp = 'yelp',
}

export enum ModuleGroup {
    Action = 1,
    Review = 2,
    Social = 3,
    Messaging = 4,
    Surveys = 5,
}
